export const setSearchParam = (
  params: URLSearchParams,
  name: string,
  value: string,
  omitted?: string,
) => {
  const next = new URLSearchParams(params);
  if (value === omitted) next.delete(name);
  else next.set(name, value);
  return next;
};

export const deleteSearchParams = (params: URLSearchParams, keys: string[]) => {
  keys.forEach((key) => {
    if (params.has(key)) {
      params.delete(key);
    }
  });

  return params;
};

export const addSearchParams = (
  params: URLSearchParams,
  keys: { name: string; value: string }[],
) => {
  keys.forEach((key) => {
    params.set(key.name, key.value);
  });

  return params;
};
